/* =========================================
   MS7 JUDGE.ME RATING → REVIEWS ACCORDION
   ========================================= */

document.addEventListener('click', function (event) {

  const rating = event.target.closest('.ms7-product-rating');

  if (!rating) return;

  event.preventDefault();

  const accordions = document.querySelectorAll(
    '.product__accordion details'
  );

  let reviewsAccordion = null;

  accordions.forEach(function (accordion) {

    const summary = accordion.querySelector('summary');

    if (
      summary &&
      summary.textContent.trim().toLowerCase() === 'reviews'
    ) {
      reviewsAccordion = accordion;
    }

  });

  if (!reviewsAccordion) return;

  /* Open Reviews */
  reviewsAccordion.open = true;

  /* Scroll to Reviews */
  setTimeout(function () {

    reviewsAccordion.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

  }, 100);

});